import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _isNativeReflectConstruct from "@babel/runtime/helpers/isNativeReflectConstruct";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import { createRef, PureComponent } from 'react';
import cn from 'classnames';
import { css } from 'styled-components';
import VolumeOff from '@crehana/icons/outline/VolumeOff';
import VolumeUp from '@crehana/icons/outline/VolumeUp';
import { Tooltip } from '@crehana/ui';
import { ControlButton } from "../ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var VERTICAL_PROGRESS_SIZE = 40;
var HORIZONTAL_PROGRESS_SIZE = 64;
var VolumeBar = /*#__PURE__*/function (_PureComponent) {
  function VolumeBar(props) {
    var _this;
    _classCallCheck(this, VolumeBar);
    _this = _callSuper(this, VolumeBar, [props]);
    // Ref to the root progress element
    _this.progressRef = /*#__PURE__*/createRef();
    _this.onMouseUp = function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('mousemove', _this.onMouseMove, true);
      }
    };
    _this.onHandlePositionChangeVertical = function (clientY) {
      var changeVolume = _this.props.changeVolume;
      if (_this.progressRef.current && document) {
        var bodyRect = document.body.getBoundingClientRect();
        var progressRect = _this.progressRef.current.getBoundingClientRect();
        var progressOffset = progressRect.top - bodyRect.top;
        var mousePosition = clientY - progressOffset;
        var newVolume = (VERTICAL_PROGRESS_SIZE - mousePosition) / VERTICAL_PROGRESS_SIZE;
        if (newVolume < 0) {
          newVolume = 0;
        } else if (newVolume > 1) {
          newVolume = 1;
        }
        changeVolume(newVolume);
      }
    };
    _this.onHandlePositionChangeHorizontal = function (clientX) {
      var changeVolume = _this.props.changeVolume;
      if (_this.progressRef.current && document) {
        var bodyRect = document.body.getBoundingClientRect();
        var progressRect = _this.progressRef.current.getBoundingClientRect();
        var progressOffset = progressRect.left - bodyRect.left;
        var mousePosition = clientX - progressOffset;
        var newVolume = mousePosition / HORIZONTAL_PROGRESS_SIZE;
        if (newVolume < 0) {
          newVolume = 0;
        } else if (newVolume > 1) {
          newVolume = 1;
        }
        changeVolume(newVolume);
      }
    };
    _this.onMouseMove = function (e) {
      if (_this.props.vertical) {
        _this.onHandlePositionChangeVertical(e.clientY);
      } else {
        _this.onHandlePositionChangeHorizontal(e.clientX);
      }
    };
    _this.onMouseDown = function (e) {
      if (_this.progressRef.current && document) {
        if (_this.props.vertical) {
          _this.onHandlePositionChangeVertical(e.clientY);
        } else {
          _this.onHandlePositionChangeHorizontal(e.clientX);
        }
        if (typeof window !== 'undefined') {
          window.addEventListener('mousemove', _this.onMouseMove, true);
        }
      }
    };
    _this.onHover = function () {
      _this.setState({
        showBar: true
      });
    };
    _this.onBlur = function () {
      _this.setState({
        showBar: false
      });
    };
    _this.state = {
      showBar: false
    };
    return _this;
  }
  _inherits(VolumeBar, _PureComponent);
  return _createClass(VolumeBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (typeof window !== 'undefined') {
        window.addEventListener('mouseup', this.onMouseUp, true);
      }
      return function () {
        if (typeof window !== 'undefined') {
          window.removeEventListener('mousemove', _this2.onMouseMove, true);
          window.removeEventListener('mouseup', _this2.onMouseUp, true);
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        muted = _this$props.muted,
        toggleMute = _this$props.toggleMute,
        volume = _this$props.volume,
        className = _this$props.className,
        vertical = _this$props.vertical,
        visibleUi = _this$props.visibleUi,
        buttonLabel = _this$props.buttonLabel,
        tooltipLabel = _this$props.tooltipLabel,
        isSm = _this$props.isSm;
      var showBar = this.state.showBar;
      return /*#__PURE__*/_jsxs("div", {
        className: cn('flex items-center', {
          'flex-col-reverse': vertical
        }, className),
        onMouseEnter: this.onHover,
        onMouseDown: this.onHover,
        onMouseLeave: this.onBlur,
        "data-testid": "cp-volume-bar",
        children: [tooltipLabel ? /*#__PURE__*/_jsx(Tooltip, {
          label: tooltipLabel,
          position: vertical ? 'bottom' : 'top',
          isDark: true,
          children: /*#__PURE__*/_jsx("div", {
            className: cn('flex items-center relative', vertical ? 'mt-8' : 'mr-8'),
            children: /*#__PURE__*/_jsx(ControlButton, {
              icon: {
                component: muted ? VolumeOff : VolumeUp
              },
              onClick: toggleMute,
              "aria-label": buttonLabel,
              isSm: isSm
            })
          })
        }) : /*#__PURE__*/_jsx(ControlButton, {
          className: vertical ? 'mt-8' : 'mr-8',
          icon: {
            component: muted ? VolumeOff : VolumeUp
          },
          onClick: toggleMute,
          "aria-label": buttonLabel,
          isSm: isSm
        }), /*#__PURE__*/_jsxs(_StyledDiv, {
          ref: this.progressRef,
          className: cn('cp-progress relative flex items-center z-1', visibleUi ? 'cursor-pointer' : 'cursor-none', _defineProperty(_defineProperty({}, "flex-col justify-end ".concat(showBar ? 'w-4 h-40 opacity-1' : 'w-4 h-0 opacity-0'), vertical), showBar ? 'h-8 w-64 opacity-1' : 'h-8 w-0 opacity-0', !vertical)),
          onMouseDown: this.onMouseDown,
          "data-testid": "cp-volume-bar-progress",
          children: [/*#__PURE__*/_jsx("div", {
            className: "absolute left-0 bg-gray-dark z-0 ".concat(vertical ? 'w-4 h-full' : 'h-4 w-full')
          }), /*#__PURE__*/_jsx(_StyledDiv2, {
            className: "absolute left-0 bg-white z-1 ".concat(vertical ? 'w-4' : 'h-4'),
            "data-testid": "cp-volume-bar-progress-indicator",
            $_css: vertical ? css(["\n                    height: ", "%;\n                    transition: ", ";\n                  "], muted ? 0 : volume * 100, function (_ref) {
              var theme = _ref.theme;
              return theme.transition('height');
            }) : css(["\n                    width: ", "%;\n                    transition: ", ";\n                  "], muted ? 0 : volume * 100, function (_ref2) {
              var theme = _ref2.theme;
              return theme.transition('width');
            }),
            children: /*#__PURE__*/_jsx("div", {
              className: "absolute w-8 h-8 bg-white rounded-full",
              style: vertical ? {
                left: '-2px',
                top: '-4px'
              } : {
                bottom: '-2px',
                right: '-4px'
              }
            })
          })]
        })]
      });
    }
  }]);
}(PureComponent);
export default VolumeBar;
var _StyledDiv = /*#__PURE__*/_styled("div")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n            transition: ", ";\n          "])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition(['height', 'width', 'opacity']);
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  componentId: "sc-vnl9f3-0"
})(["", ""], function (p) {
  return p.$_css;
});